export const BUSINESS_VALUE_TICKET_TYPE_KEYS = new Set([
  'code report',
  'static report',
  'security',
  'integration suite',
  'workflow',
]);

export const BUSINESS_VALUE_TICKET_TYPE_ORDER = [
  'code report',
  'static report',
  'security',
  'integration suite',
  'workflow',
];

export const BUSINESS_VALUE_SHORT_LABELS = {
  'code report': 'ABAP',
  'static report': 'HTML',
  security: 'Security',
  workflow: 'NUP',
};

export function filterBusinessValueRows(rows) {
  return (rows || [])
    .filter((row) => BUSINESS_VALUE_TICKET_TYPE_KEYS.has(row.ticket_type_key))
    .sort(
      (a, b) =>
        BUSINESS_VALUE_TICKET_TYPE_ORDER.indexOf(a.ticket_type_key)
        - BUSINESS_VALUE_TICKET_TYPE_ORDER.indexOf(b.ticket_type_key),
    );
}

export function filterBusinessValueSettings(settings) {
  return filterBusinessValueRows(settings);
}

/** Drill-down Category column: Vibe sessions vs ServiceNow / workflow tickets. */
export function businessValueCategoryLabel(row) {
  if (!row) return '—';
  if (row.group_type === 'session') return 'Chat';
  if (row.group_type === 'ticket') return 'Workflow';
  if (row.ticket_type_key === 'workflow') return 'Workflow';
  return 'Chat';
}
